import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../App";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";
import { DialogoFechaCaja } from "../../components/DialogoFechaCaja";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../../components/ui/command";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Checkbox } from "../../components/ui/checkbox";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../components/ui/dropdown-menu";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, ChevronsUpDown, Check, Calculator, Info, Send, Download, FileSpreadsheet, File, FileType, FileJson, FileText } from "lucide-react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { saveAs } from "file-saver";

const API = process.env.REACT_APP_BACKEND_URL;

const mesesOpciones = [
  { value: 1, label: "Enero" }, { value: 2, label: "Febrero" }, { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" }, { value: 5, label: "Mayo" }, { value: 6, label: "Junio" },
  { value: 7, label: "Julio" }, { value: 8, label: "Agosto" }, { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" }, { value: 11, label: "Noviembre" }, { value: 12, label: "Diciembre" }
];

const mesShort = {
  1: "Ene", 2: "Feb", 3: "Mar", 4: "Abr", 5: "May", 6: "Jun",
  7: "Jul", 8: "Ago", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dic"
};

const mesLabels = {
  1: "ENERO", 2: "FEBRERO", 3: "MARZO", 4: "ABRIL", 5: "MAYO", 6: "JUNIO",
  7: "JULIO", 8: "AGOSTO", 9: "SEPTIEMBRE", 10: "OCTUBRE", 11: "NOVIEMBRE", 12: "DICIEMBRE"
};

const generatePendingMeses = (lastMes, lastAnio) => {
  if (!lastMes || !lastAnio) return [];
  const currentYear = new Date().getFullYear();
  const pending = [];
  let m = parseInt(lastMes);
  let y = parseInt(lastAnio);
  m++;
  if (m > 12) { m = 1; y++; }
  while (y < currentYear || (y === currentYear && m <= 12)) {
    pending.push({
      mes: m, anio: y,
      key: `${m}-${y}`,
      label: `${mesLabels[m]} ${y}`
    });
    m++;
    if (m > 12) { m = 1; y++; }
  }
  return pending;
};

const findClasificadorForMes = (clasificadorItems) => {
  return clasificadorItems.length > 0 ? clasificadorItems[0] : null;
};

const CalculoAmbulantes = () => {
  const { token } = useAuth();
  const headers = { Authorization: `Bearer ${token}` };

  const [items, setItems] = useState([]);
  const [formData, setFormData] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [fechaCajaDialogOpen, setFechaCajaDialogOpen] = useState(false);
  const [calculoParaEnviar, setCalculoParaEnviar] = useState(null);

  const esMesActual = (fecha) => {
    if (!fecha) return false;
    const hoy = new Date();
    const [y, m] = fecha.split("-");
    return parseInt(y) === hoy.getFullYear() && parseInt(m) === (hoy.getMonth() + 1);
  };
  const [contribuyentes, setContribuyentes] = useState([]);
  const [rifPopoverOpen, setRifPopoverOpen] = useState(false);
  const [oficinas, setOficinas] = useState([]);
  const [filters, setFilters] = useState({ nro: "", rif: "", nombre: "", fecha: "", total: "", estatus_pago: "", estatus: "" });

  // Meses pendientes
  const [conTasasMeses, setConTasasMeses] = useState(false);
  const [mesesPendientes, setMesesPendientes] = useState([]);
  const [mesesSeleccionados, setMesesSeleccionados] = useState([]);
  const [valorUnidadCuenta, setValorUnidadCuenta] = useState(0);
  const [valorDolar, setValorDolar] = useState(0);
  const [valorEuro, setValorEuro] = useState(0);
  const [clasificadorAmb, setClasificadorAmb] = useState([]);

  useEffect(() => { fetchCalculos(); }, []);

  const fetchCalculos = async () => {
    try { const r = await axios.get(`${API}/api/ambulantes/calculo`, { headers }); setItems(r.data); }
    catch { toast.error("Error al cargar calculos"); }
  };
  const fetchContribuyentes = async () => {
    try { const r = await axios.get(`${API}/api/ambulantes/registro`, { headers }); setContribuyentes(r.data); }
    catch { setContribuyentes([]); }
  };
  const fetchOficinas = async () => {
    try { const r = await axios.get(`${API}/api/definiciones/oficinas`, { headers }); setOficinas(r.data); }
    catch { setOficinas([]); }
  };
  const fetchCotizacionActiva = async () => {
    try {
      const r = await axios.get(`${API}/api/publicidad/cotizacion-activa`, { headers });
      setValorUnidadCuenta(r.data.valor_unidad_cuenta || 0);
      setValorDolar(r.data.dolar || 0);
      setValorEuro(r.data.euro || 0);
      return r.data.valor_unidad_cuenta || 0;
    } catch {
      return 0;
    }
  };
  const fetchClasificadorAmb = async () => {
    try { const r = await axios.get(`${API}/api/ambulantes/clasificador`, { headers }); setClasificadorAmb(r.data); return r.data; }
    catch { setClasificadorAmb([]); return []; }
  };

  // ============ SAVE ============
  const handleSave = async (overrideData) => {
    const payload = overrideData || formData;
    if (!payload.rif) { toast.error("RIF / Contribuyente es obligatorio"); return; }
    try {
      if (editingItem) {
        await axios.put(`${API}/api/ambulantes/calculo/${editingItem.id}`, payload, { headers });
        toast.success("Calculo actualizado exitosamente");
      } else {
        await axios.post(`${API}/api/ambulantes/calculo`, payload, { headers });
        toast.success("Calculo creado exitosamente");
      }
      setDialogOpen(false); resetForm(); fetchCalculos();
    } catch (error) { toast.error(error.response?.data?.detail || "Error al guardar"); }
  };

  const resetForm = () => {
    setFormData({});
    setEditingItem(null);
    setConTasasMeses(false);
    setMesesPendientes([]);
    setMesesSeleccionados([]);
  };

  const openNew = async () => {
    resetForm();

    // Auto-montaje de tipos de impuesto anclados a Vendedores Ambulantes
    let anclados = [];
    try {
      const res = await axios.get(`${API}/api/definiciones/tipos-impuesto/anclados/ambulantes`, { headers });
      anclados = (res.data || []).map((ti) => ({
        tipo_impuesto_id: ti.id, tipo_impuesto_nombre: ti.nombre, concepto: ti.nombre,
        descripcion: ti.descripcion || ti.nombre, tasa: ti.tasa || 0,
        cantidad: 1, sub_total: 0,
        codigo_presupuestario_id: ti.codigo_presupuestario_id || null, _anclado: true,
      }));
    } catch (err) { console.warn("[anclados/ambulantes]", err); toast.warning("No se pudieron cargar los impuestos anclados"); }

    setFormData({ clase_contribuyente: "Contribuyente sin LAE", lineas_impuestos: anclados, fecha: new Date().toISOString().split("T")[0] });
    fetchContribuyentes();
    await fetchCotizacionActiva();
    await fetchClasificadorAmb();
    fetchOficinas();
    setDialogOpen(true);
  };

  const openEdit = async (item) => {
    setEditingItem(item);
    setFormData({ ...item, clase_contribuyente: "Contribuyente sin LAE" });
    fetchContribuyentes();
    await fetchCotizacionActiva();
    await fetchClasificadorAmb();
    fetchOficinas();
    if (item.con_tasas_meses && item.ultimo_mes && item.ultimo_anio) {
      setConTasasMeses(true);
      const pending = generatePendingMeses(item.ultimo_mes, item.ultimo_anio);
      setMesesPendientes(pending);
      const sel = (item.lineas_impuestos || [])
        .filter(l => l.auto_mes)
        .map(l => l.mes_key)
        .filter(Boolean);
      setMesesSeleccionados(sel);
    }
    setDialogOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${API}/api/ambulantes/calculo/${itemToDelete.id}`, { headers });
      toast.success("Calculo eliminado"); setDeleteDialogOpen(false); setItemToDelete(null); fetchCalculos();
    } catch { toast.error("Error al eliminar"); }
  };

  const handleEnviarACaja = async (calculo, actualizarFecha = false) => {
    try {
      const url = `${API}/api/ambulantes/calculo/${calculo.id}/enviar-caja${actualizarFecha ? '?actualizar_fecha=true' : ''}`;
      const res = await axios.post(url, {}, { headers });
      toast.success(`Calculo enviado a caja. Planilla: ${res.data.nro_planilla}`);
      fetchCalculos();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al enviar a caja");
    }
  };

  const handleEnviarACajaClick = (calculo) => {
    if (!esMesActual(calculo.fecha)) {
      setCalculoParaEnviar(calculo);
      setFechaCajaDialogOpen(true);
    } else {
      handleEnviarACaja(calculo);
    }
  };

  // ============ CONTRIBUYENTE SELECTION ============
  const handleContribuyenteSelect = (c) => {
    const rif = c.rif || "";
    const nombre = c.nombre_razon_social || "";
    const mesPago = c.ultimo_mes || null;
    const anioPago = c.ultimo_anio || null;

    const newFormData = {
      ...formData, rif, nombre_razon_social: nombre,
      ultimo_mes: mesPago ? parseInt(mesPago) : formData.ultimo_mes,
      ultimo_anio: anioPago ? parseInt(anioPago) : formData.ultimo_anio,
    };
    setFormData(newFormData);
    setRifPopoverOpen(false);

    if (mesPago && anioPago) {
      const pending = generatePendingMeses(mesPago, anioPago);
      setMesesPendientes(pending);
      if (conTasasMeses) {
        setMesesSeleccionados([]);
        setFormData(prev => ({ ...prev, ...newFormData, lineas_impuestos: (prev.lineas_impuestos || []).filter(l => !l.auto_mes) }));
      }
    } else {
      setMesesPendientes([]);
    }
  };

  // ============ MESES CHECKBOX LOGIC ============
  const handleToggleTasasMeses = async (checked) => {
    setConTasasMeses(checked);
    if (!checked) {
      const manualLines = (formData.lineas_impuestos || []).filter(l => !l.auto_mes);
      setFormData({ ...formData, lineas_impuestos: manualLines, con_tasas_meses: false });
      setMesesSeleccionados([]);
    } else {
      await fetchClasificadorAmb();
      setFormData({ ...formData, con_tasas_meses: true });
      if (formData.ultimo_mes && formData.ultimo_anio) {
        const pending = generatePendingMeses(formData.ultimo_mes, formData.ultimo_anio);
        setMesesPendientes(pending);
      }
    }
  };

  const handleMesCheckbox = (mesKey, isChecked) => {
    const idx = mesesPendientes.findIndex(m => m.key === mesKey);
    if (idx === -1) return;

    let newSelected;
    if (isChecked) {
      const keysToSelect = mesesPendientes.slice(0, idx + 1).map(m => m.key);
      newSelected = [...new Set([...mesesSeleccionados, ...keysToSelect])];
    } else {
      const keysToDeselect = new Set(mesesPendientes.slice(idx).map(m => m.key));
      newSelected = mesesSeleccionados.filter(k => !keysToDeselect.has(k));
    }
    setMesesSeleccionados(newSelected);

    const manualLines = (formData.lineas_impuestos || []).filter(l => !l.auto_mes);
    const autoLines = newSelected.map(key => {
      const mp = mesesPendientes.find(m => m.key === key);
      if (!mp) return null;
      const clasif = findClasificadorForMes(clasificadorAmb);
      const tasa = clasif ? (clasif.tasa || 0) : 0;
      const concepto = `ACT. ECO. AMBULANTE ${mesLabels[mp.mes]} ${mp.anio}`;
      const existing = (formData.lineas_impuestos || []).find(l => l.mes_key === key);
      const finalImporte = existing && existing.importe_manual ? existing.importe : tasa;
      const subTotal = valorUnidadCuenta * finalImporte;
      return {
        linea_id: `auto-${key}`,
        mes_key: key,
        auto_mes: true,
        impuesto_tasa: concepto,
        ingreso_bruto: valorUnidadCuenta,
        importe: finalImporte,
        sub_total: subTotal
      };
    }).filter(Boolean);

    setFormData(prev => ({ ...prev, lineas_impuestos: [...autoLines, ...manualLines] }));
  };

  // ============ LINEAS MANUALES ============
  const addLinea = () => {
    const lineas = [...(formData.lineas_impuestos || [])];
    lineas.push({ linea_id: Date.now().toString(), impuesto_tasa: "", ingreso_bruto: 0, importe: 0, sub_total: 0 });
    setFormData({ ...formData, lineas_impuestos: lineas });
  };

  const updateLinea = (index, field, value) => {
    const lineas = [...(formData.lineas_impuestos || [])];
    lineas[index] = { ...lineas[index], [field]: value };
    if (field === "ingreso_bruto" || field === "importe") {
      const ib = field === "ingreso_bruto" ? (parseFloat(value) || 0) : (parseFloat(lineas[index].ingreso_bruto) || 0);
      const imp = field === "importe" ? (parseFloat(value) || 0) : (parseFloat(lineas[index].importe) || 0);
      lineas[index].sub_total = ib * imp;
    }
    setFormData({ ...formData, lineas_impuestos: lineas });
  };

  const removeLinea = (index) => {
    const lineas = [...(formData.lineas_impuestos || [])];
    const removed = lineas[index];
    lineas.splice(index, 1);
    if (removed?.auto_mes && removed?.mes_key) {
      const mIdx = mesesPendientes.findIndex(m => m.key === removed.mes_key);
      if (mIdx !== -1) {
        const keysToDeselect = new Set(mesesPendientes.slice(mIdx).map(m => m.key));
        const newSelected = mesesSeleccionados.filter(k => !keysToDeselect.has(k));
        setMesesSeleccionados(newSelected);
        const finalLines = lineas.filter(l => !l.auto_mes || !keysToDeselect.has(l.mes_key));
        setFormData({ ...formData, lineas_impuestos: finalLines });
        return;
      }
    }
    setFormData({ ...formData, lineas_impuestos: lineas });
  };

  const calcTotal = () => {
    const subTotalLineas = (formData.lineas_impuestos || []).reduce((s, l) => s + (l.sub_total || 0), 0);
    return subTotalLineas - (formData.descuento || 0) + (formData.multa || 0);
  };

  // ============ FILTER ============
  const filtered = items.filter(item => {
    const f = filters;
    if (f.nro && !(item.nro_boletin_ambulantes || "").toLowerCase().includes(f.nro.toLowerCase())) return false;
    if (f.rif && !(item.rif || "").toLowerCase().includes(f.rif.toLowerCase())) return false;
    if (f.nombre && !(item.nombre_razon_social || "").toLowerCase().includes(f.nombre.toLowerCase())) return false;
    if (f.fecha && !(item.fecha || "").includes(f.fecha)) return false;
    if (f.total && !String(item.total || "").includes(f.total)) return false;
    if (f.estatus_pago && f.estatus_pago !== "todos" && (item.estatus_pago || "Sin pagar") !== f.estatus_pago) return false;
    if (f.estatus && f.estatus !== "todos" && (item.estatus || "Registrado") !== f.estatus) return false;
    return true;
  });

  // ============ EXPORT ============
  const getExportData = () => filtered.map(item => ({
    "Nro.": item.nro_boletin_ambulantes || "",
    "RIF": item.rif || "",
    "Contribuyente": item.nombre_razon_social || "",
    "Fecha": item.fecha || "",
    "Total (Bs.)": (item.total || 0).toFixed(2),
    "Estatus Pago": item.estatus_pago || "Sin pagar",
    "Estatus": item.estatus || "Registrado"
  }));

  const exportToExcel = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } const ws = XLSX.utils.json_to_sheet(d); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, "Calculo Ambulantes"); XLSX.writeFile(wb, `calculo_ambulantes_${new Date().toISOString().split("T")[0]}.xlsx`); toast.success("Exportado a Excel exitosamente"); };
  const exportToPDF = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } const doc = new jsPDF("landscape"); doc.setFontSize(16); doc.text("Cálculo Vendedores Ambulantes", 14, 20); doc.setFontSize(10); doc.text(`Fecha: ${new Date().toLocaleDateString("es-VE")}`, 14, 28); autoTable(doc, { head: [Object.keys(d[0])], body: d.map(r => Object.values(r)), startY: 35, styles: { fontSize: 7 }, headStyles: { fillColor: [234, 88, 12] } }); doc.save(`calculo_ambulantes_${new Date().toISOString().split("T")[0]}.pdf`); toast.success("Exportado a PDF exitosamente"); };
  const exportToCSV = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } const h = Object.keys(d[0]).join(","); const rows = d.map(r => Object.values(r).map(v => `"${v}"`).join(",")).join("\n"); saveAs(new Blob(["\ufeff" + h + "\n" + rows], { type: "text/csv;charset=utf-8" }), `calculo_ambulantes_${new Date().toISOString().split("T")[0]}.csv`); toast.success("Exportado a CSV exitosamente"); };
  const exportToText = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } const hs = Object.keys(d[0]); const cw = hs.map(h => Math.max(h.length, ...d.map(r => String(r[h]).length))); let t = "CÁLCULO VENDEDORES AMBULANTES\n"; t += `Fecha: ${new Date().toLocaleDateString("es-VE")}\n`; t += "=".repeat(Math.max(cw.reduce((a, b) => a + b + 3, 0), 50)) + "\n\n"; t += hs.map((h, i) => h.padEnd(cw[i])).join(" | ") + "\n"; t += cw.map(w => "-".repeat(w)).join("-+-") + "\n"; d.forEach(r => { t += hs.map((h, i) => String(r[h]).padEnd(cw[i])).join(" | ") + "\n"; }); saveAs(new Blob([t], { type: "text/plain;charset=utf-8" }), `calculo_ambulantes_${new Date().toISOString().split("T")[0]}.txt`); toast.success("Exportado a Texto exitosamente"); };
  const exportToHTML = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } const hs = Object.keys(d[0]); const html = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8"><title>Cálculo Vendedores Ambulantes</title><style>body{font-family:Arial,sans-serif;padding:20px}h1{color:#ea580c}table{border-collapse:collapse;width:100%;margin-top:20px}th,td{border:1px solid #ddd;padding:10px;text-align:left;font-size:12px}th{background-color:#ea580c;color:white}tr:nth-child(even){background-color:#f9fafb}tr:hover{background-color:#f3f4f6}.fecha{color:#6b7280;margin-bottom:20px}</style></head><body><h1>Cálculo Vendedores Ambulantes</h1><p class="fecha">Fecha: ${new Date().toLocaleDateString("es-VE")}</p><table><thead><tr>${hs.map(h => `<th>${h}</th>`).join("")}</tr></thead><tbody>${d.map(r => `<tr>${Object.values(r).map(v => `<td>${v}</td>`).join("")}</tr>`).join("")}</tbody></table></body></html>`; saveAs(new Blob([html], { type: "text/html;charset=utf-8" }), `calculo_ambulantes_${new Date().toISOString().split("T")[0]}.html`); toast.success("Exportado a HTML exitosamente"); };
  const exportToJSON = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } saveAs(new Blob([JSON.stringify(d, null, 2)], { type: "application/json" }), `calculo_ambulantes_${new Date().toISOString().split("T")[0]}.json`); toast.success("Exportado a JSON exitosamente"); };

  // ============ RENDER ============
  return (
    <div className="space-y-6" data-testid="calculo-ambulantes-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Cálculo Vendedores Ambulantes</h1>
          <p className="text-slate-500">Gestión de cálculos de vendedores ambulantes</p>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-lg text-sm" data-testid="registro-counter">
            <span className="font-bold text-blue-800">{filtered.length}</span>
            <span className="text-blue-600">de</span>
            <span className="font-bold text-blue-800">{items.length}</span>
            <span className="text-blue-600">registros</span>
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="gap-2" data-testid="btn-exportar-calc-amb"><Download className="w-4 h-4" /> Exportar</Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={exportToExcel} className="gap-2 cursor-pointer"><FileSpreadsheet className="w-4 h-4" /> Excel</DropdownMenuItem>
              <DropdownMenuItem onClick={exportToPDF} className="gap-2 cursor-pointer"><FileText className="w-4 h-4" /> PDF</DropdownMenuItem>
              <DropdownMenuItem onClick={exportToCSV} className="gap-2 cursor-pointer"><FileText className="w-4 h-4" /> CSV</DropdownMenuItem>
              <DropdownMenuItem onClick={exportToText} className="gap-2 cursor-pointer"><File className="w-4 h-4" /> Texto</DropdownMenuItem>
              <DropdownMenuItem onClick={exportToHTML} className="gap-2 cursor-pointer"><FileType className="w-4 h-4" /> HTML</DropdownMenuItem>
              <DropdownMenuItem onClick={exportToJSON} className="gap-2 cursor-pointer"><FileJson className="w-4 h-4" /> JSON</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <Button onClick={openNew} className="bg-orange-600 hover:bg-orange-700" data-testid="btn-nuevo-calculo-amb">
            <Plus className="w-4 h-4 mr-2" /> Nuevo
          </Button>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-slate-50">
              <TableHead>Nro.</TableHead><TableHead>RIF</TableHead><TableHead>Contribuyente</TableHead>
              <TableHead>Fecha</TableHead><TableHead className="text-right">Total (Bs.)</TableHead>
              <TableHead>Estatus Pago</TableHead><TableHead>Estatus</TableHead><TableHead className="text-right">Acciones</TableHead>
            </TableRow>
            <TableRow className="bg-slate-50/50 border-b">
              <TableHead className="px-2 py-1.5"><Input className="h-7 text-xs" placeholder="Filtrar..." value={filters.nro} onChange={(e) => setFilters({...filters, nro: e.target.value})} data-testid="filter-calcamb-nro" /></TableHead>
              <TableHead className="px-2 py-1.5"><Input className="h-7 text-xs" placeholder="Filtrar..." value={filters.rif} onChange={(e) => setFilters({...filters, rif: e.target.value})} data-testid="filter-calcamb-rif" /></TableHead>
              <TableHead className="px-2 py-1.5"><Input className="h-7 text-xs" placeholder="Filtrar..." value={filters.nombre} onChange={(e) => setFilters({...filters, nombre: e.target.value})} data-testid="filter-calcamb-nombre" /></TableHead>
              <TableHead className="px-2 py-1.5"><Input type="date" className="h-7 text-xs" value={filters.fecha} onChange={(e) => setFilters({...filters, fecha: e.target.value})} data-testid="filter-calcamb-fecha" /></TableHead>
              <TableHead className="px-2 py-1.5"><Input className="h-7 text-xs text-right" placeholder="Filtrar..." value={filters.total} onChange={(e) => setFilters({...filters, total: e.target.value})} data-testid="filter-calcamb-total" /></TableHead>
              <TableHead className="px-2 py-1.5">
                <select className="h-7 w-full text-xs border rounded-md px-1 bg-white text-slate-700" value={filters.estatus_pago} onChange={(e) => setFilters({...filters, estatus_pago: e.target.value})} data-testid="filter-calcamb-estatus-pago">
                  <option value="todos">Todos</option><option value="Sin pagar">Sin pagar</option><option value="Pagado">Pagado</option>
                </select>
              </TableHead>
              <TableHead className="px-2 py-1.5">
                <select className="h-7 w-full text-xs border rounded-md px-1 bg-white text-slate-700" value={filters.estatus} onChange={(e) => setFilters({...filters, estatus: e.target.value})} data-testid="filter-calcamb-estatus">
                  <option value="todos">Todos</option><option value="Registrado">Registrado</option><option value="Enviado a Caja">Enviado a Caja</option><option value="Anulado">Anulado</option>
                </select>
              </TableHead>
              <TableHead className="px-2 py-1.5"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.length === 0 ? (
              <TableRow><TableCell colSpan={8} className="text-center py-8 text-slate-400">No hay calculos</TableCell></TableRow>
            ) : filtered.map((item) => (
              <TableRow key={item.id}>
                <TableCell className="font-mono text-sm">{item.nro_boletin_ambulantes}</TableCell>
                <TableCell className="font-mono text-sm">{item.rif}</TableCell>
                <TableCell className="text-sm">{item.nombre_razon_social || "-"}</TableCell>
                <TableCell className="text-sm">{item.fecha || "-"}</TableCell>
                <TableCell className="text-sm text-right font-medium">{(item.total || 0).toLocaleString("es-VE", { minimumFractionDigits: 2 })}</TableCell>
                <TableCell>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${item.estatus_pago === "Pagado" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>
                    {item.estatus_pago || "Sin pagar"}
                  </span>
                </TableCell>
                <TableCell>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${item.estatus === "Enviado a Caja" ? "bg-blue-100 text-blue-700" : item.estatus === "Anulado" ? "bg-red-100 text-red-700" : "bg-slate-100 text-slate-700"}`}>
                    {item.estatus || "Registrado"}
                  </span>
                </TableCell>
                <TableCell className="text-right">
                  <div className="flex justify-end gap-1">
                    {item.estatus !== "Enviado a Caja" && item.estatus !== "Anulado" && (
                      <Button variant="ghost" size="icon" title="Enviar a Caja" onClick={() => handleEnviarACajaClick(item)} data-testid={`btn-enviar-caja-amb-${item.id}`}><Send className="w-4 h-4 text-green-600" /></Button>
                    )}
                    <Button variant="ghost" size="icon" onClick={() => openEdit(item)} data-testid={`btn-edit-amb-${item.id}`}><Pencil className="w-4 h-4 text-blue-600" /></Button>
                    <Button variant="ghost" size="icon" onClick={() => { setItemToDelete(item); setDeleteDialogOpen(true); }} data-testid={`btn-delete-amb-${item.id}`}><Trash2 className="w-4 h-4 text-red-500" /></Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {/* Form Dialog */}
      <Dialog open={dialogOpen} onOpenChange={(open) => { if (!open) resetForm(); setDialogOpen(open); }}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Calculator className="w-5 h-5 text-orange-600" />
              {editingItem ? "Editar Cálculo" : "Nuevo Cálculo Vendedores Ambulantes"}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Clase de Contribuyente</Label>
                <Input value="Contribuyente sin LAE" readOnly className="bg-slate-50" data-testid="form-clase-calculo-amb" />
              </div>
              <div className="space-y-2">
                <Label>Fecha</Label>
                <Input type="date" value={formData.fecha || ""} onChange={(e) => setFormData({ ...formData, fecha: e.target.value })} data-testid="form-fecha-calculo-amb" />
              </div>
            </div>

            {/* RIF Selector */}
            <div className="space-y-2">
              <Label>RIF / Contribuyente *</Label>
              <Popover open={rifPopoverOpen} onOpenChange={setRifPopoverOpen}>
                <PopoverTrigger asChild>
                  <Button variant="outline" role="combobox" className="w-full justify-between h-auto min-h-[40px] text-left font-normal" data-testid="form-rif-contribuyente-amb">
                    {formData.rif ? `${formData.rif} - ${formData.nombre_razon_social || ""}` : "Seleccione contribuyente"}
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-[450px] p-0" align="start">
                  <Command>
                    <CommandInput placeholder="Buscar por RIF o nombre..." />
                    <CommandList>
                      <CommandEmpty>No se encontraron contribuyentes</CommandEmpty>
                      <CommandGroup>
                        {contribuyentes.map((c) => (
                          <CommandItem
                            key={c.id || c.rif}
                            value={`${c.rif} ${c.nombre_razon_social || ""}`}
                            onSelect={() => handleContribuyenteSelect(c)}
                          >
                            <Check className={`mr-2 h-4 w-4 ${formData.rif === c.rif ? "opacity-100" : "opacity-0"}`} />
                            <span className="text-sm">{c.rif} - {c.nombre_razon_social || ""}</span>
                          </CommandItem>
                        ))}
                      </CommandGroup>
                    </CommandList>
                  </Command>
                </PopoverContent>
              </Popover>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Nombre / Razón Social</Label>
                <Input value={formData.nombre_razon_social || ""} readOnly className="bg-slate-50" data-testid="form-nombre-calculo-amb" />
              </div>
              <div className="space-y-2">
                <Label>Oficina</Label>
                <Select value={formData.oficina || ""} onValueChange={(v) => setFormData({...formData, oficina: v})}>
                  <SelectTrigger data-testid="form-oficina-calculo-amb"><SelectValue placeholder="Seleccione oficina" /></SelectTrigger>
                  <SelectContent>
                    {oficinas.map((o) => <SelectItem key={o.id || o.nombre} value={o.nombre}>{o.nombre}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
            </div>

            {/* Ultimo Mes de actividad Eco. pago */}
            <div className="bg-slate-50 rounded-lg p-4 border">
              <h3 className="text-sm font-semibold text-slate-700 mb-3">Último Mes de actividad Eco. pago</h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Mes</Label>
                  <Select value={String(formData.ultimo_mes || "")} onValueChange={(v) => {
                    const newForm = { ...formData, ultimo_mes: parseInt(v) };
                    setFormData(newForm);
                    if (newForm.ultimo_anio) {
                      setMesesPendientes(generatePendingMeses(parseInt(v), newForm.ultimo_anio));
                      if (conTasasMeses) { setMesesSeleccionados([]); setFormData(f => ({ ...f, ...newForm, lineas_impuestos: (f.lineas_impuestos || []).filter(l => !l.auto_mes) })); }
                    }
                  }}>
                    <SelectTrigger data-testid="form-ultimo-mes-amb"><SelectValue placeholder="Seleccione mes" /></SelectTrigger>
                    <SelectContent>{mesesOpciones.map((m) => <SelectItem key={m.value} value={String(m.value)}>{m.label}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
                <div className="space-y-2">
                  <Label>Año</Label>
                  <Input type="number" value={formData.ultimo_anio ?? ""} onChange={(e) => {
                    const anio = parseInt(e.target.value) || null;
                    const newForm = { ...formData, ultimo_anio: anio };
                    setFormData(newForm);
                    if (anio && newForm.ultimo_mes) {
                      setMesesPendientes(generatePendingMeses(newForm.ultimo_mes, anio));
                      if (conTasasMeses) { setMesesSeleccionados([]); setFormData(f => ({ ...f, ...newForm, lineas_impuestos: (f.lineas_impuestos || []).filter(l => !l.auto_mes) })); }
                    }
                  }} placeholder="Ej: 2025" data-testid="form-ultimo-anio-amb" />
                </div>
              </div>
            </div>

            {/* Checkbox: Con tasas por meses */}
            <div className="flex items-center space-x-3 bg-orange-50 border border-orange-200 rounded-lg p-4" data-testid="checkbox-tasas-meses-container">
              <Checkbox
                id="con-tasas-meses"
                checked={conTasasMeses}
                onCheckedChange={handleToggleTasasMeses}
                data-testid="checkbox-tasas-meses"
              />
              <label htmlFor="con-tasas-meses" className="text-sm font-medium text-orange-800 cursor-pointer select-none">
                Con tasas por Meses de Actividad Economica?
              </label>
            </div>

            {/* Meses Pendientes */}
            {conTasasMeses && (
              <div className="bg-white rounded-lg border" data-testid="meses-pendientes-section">
                <div className="px-4 py-3 border-b bg-slate-50">
                  <h3 className="text-sm font-semibold text-slate-700">Meses Pendientes por Pago</h3>
                  {mesesPendientes.length > 0 && (
                    <p className="text-xs text-slate-500 mt-1">
                      <Info className="inline w-3 h-3 mr-1" />
                      Al seleccionar un mes, se incluyen automaticamente los meses anteriores pendientes (prelacion)
                    </p>
                  )}
                </div>
                <div className="p-4">
                  {!formData.ultimo_mes || !formData.ultimo_anio ? (
                    <p className="text-sm text-amber-600 text-center py-3">
                      Seleccione un contribuyente o ingrese el ultimo mes y ano de pago
                    </p>
                  ) : mesesPendientes.length === 0 ? (
                    <p className="text-sm text-green-600 text-center py-3">
                      No hay meses pendientes. El contribuyente esta al dia.
                    </p>
                  ) : (
                    <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
                      {mesesPendientes.map((mp) => {
                        const isSelected = mesesSeleccionados.includes(mp.key);
                        return (
                          <div
                            key={mp.key}
                            className={`flex items-center space-x-2 p-2 rounded-md border cursor-pointer transition-colors ${
                              isSelected ? "bg-orange-50 border-orange-300" : "bg-white border-slate-200 hover:bg-slate-50"
                            }`}
                            onClick={() => handleMesCheckbox(mp.key, !isSelected)}
                            data-testid={`mes-checkbox-${mp.key}`}
                          >
                            <Checkbox
                              checked={isSelected}
                              onCheckedChange={(checked) => handleMesCheckbox(mp.key, checked)}
                            />
                            <span className={`text-xs font-medium ${isSelected ? "text-orange-800" : "text-slate-600"}`}>
                              {mesShort[mp.mes]} {mp.anio}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Lineas de Impuestos/Tasas */}
            <div className="bg-white rounded-lg border">
              <div className="flex items-center justify-between px-4 py-3 border-b bg-slate-50">
                <h3 className="text-sm font-semibold text-slate-700">Lineas de Impuestos/Tasas</h3>
                <Button size="sm" variant="outline" onClick={addLinea} data-testid="btn-add-linea-amb">
                  <Plus className="w-3 h-3 mr-1" /> Agregar Linea
                </Button>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b bg-slate-50/50">
                      <th className="px-3 py-2 text-left font-medium text-slate-600">IMPUESTOS/TASAS</th>
                      <th className="px-3 py-2 text-right font-medium text-slate-600">INGRESO BRUTO</th>
                      <th className="px-3 py-2 text-right font-medium text-slate-600">IMPORTE</th>
                      <th className="px-3 py-2 text-right font-medium text-slate-600">SUB TOTAL</th>
                      <th className="px-3 py-2 w-10"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {(formData.lineas_impuestos || []).length === 0 ? (
                      <tr><td colSpan={5} className="text-center py-6 text-slate-400">No hay lineas de impuestos</td></tr>
                    ) : (formData.lineas_impuestos || []).map((linea, idx) => (
                      <tr key={linea.linea_id || idx} className="border-t" data-testid="linea-impuesto-row" data-tipo-nombre={linea.impuesto_tasa || linea.tipo_impuesto_nombre || linea.concepto || ""} data-anclado={linea._anclado ? "true" : "false"}>
                        <td className="px-3 py-2">
                          {linea.auto_mes ? (
                            <span className="text-sm font-medium text-orange-700" data-testid={`linea-concepto-amb-${idx}`}>{linea.impuesto_tasa}</span>
                          ) : (
                            <Input className="h-8 text-sm" value={linea.impuesto_tasa || ""} onChange={(e) => updateLinea(idx, "impuesto_tasa", e.target.value)} placeholder="Concepto" data-testid={`linea-concepto-amb-${idx}`} />
                          )}
                        </td>
                        <td className="px-3 py-2">
                          {linea.auto_mes ? (
                            <span className="text-sm text-right block font-mono" data-testid={`linea-ingreso-amb-${idx}`}>{(linea.ingreso_bruto || 0).toLocaleString("es-VE", { minimumFractionDigits: 2 })}</span>
                          ) : (
                            <Input type="number" step="0.01" className="h-8 text-sm text-right" value={linea.ingreso_bruto || ""} onChange={(e) => updateLinea(idx, "ingreso_bruto", e.target.value)} placeholder="0.00" data-testid={`linea-ingreso-amb-${idx}`} />
                          )}
                        </td>
                        <td className="px-3 py-2">
                          <Input type="number" step="0.01" className="h-8 text-sm text-right" value={linea.importe || ""} onChange={(e) => updateLinea(idx, "importe", e.target.value)} placeholder="0.00" data-testid={`linea-importe-amb-${idx}`} />
                        </td>
                        <td className="px-3 py-2 text-right font-medium text-slate-700">
                          {(linea.sub_total || 0).toLocaleString("es-VE", { minimumFractionDigits: 2 })}
                        </td>
                        <td className="px-3 py-2">
                          <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => removeLinea(idx)} data-testid={`btn-remove-linea-amb-${idx}`}><Trash2 className="w-3 h-3 text-red-500" /></Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {conTasasMeses && valorUnidadCuenta > 0 && (
                <div className="px-4 py-2 bg-blue-50 border-t text-xs text-blue-700">
                  Valor Unidad de Cuenta (Activa): Bs. {valorUnidadCuenta.toLocaleString("es-VE", { minimumFractionDigits: 2 })}
                </div>
              )}
            </div>

            {/* Totales */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              <div className="space-y-1">
                <Label className="text-xs">Descuento (Bs.)</Label>
                <Input type="number" step="0.01" className="h-8 text-sm text-right" value={formData.descuento ?? ""} onChange={(e) => setFormData({ ...formData, descuento: parseFloat(e.target.value) || 0 })} placeholder="0.00" data-testid="form-descuento-amb" />
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Reintegro (Bs.)</Label>
                <div className="h-8 flex items-center justify-end px-3 bg-slate-50 border border-slate-200 rounded-md text-sm font-medium text-slate-700" data-testid="form-reintegro-amb">0,00</div>
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Retencion (Bs.)</Label>
                <div className="h-8 flex items-center justify-end px-3 bg-slate-50 border border-slate-200 rounded-md text-sm font-medium text-slate-700" data-testid="form-retencion-amb">0,00</div>
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Multa (Bs.)</Label>
                <Input type="number" step="0.01" className="h-8 text-sm text-right" value={formData.multa ?? ""} onChange={(e) => setFormData({ ...formData, multa: parseFloat(e.target.value) || 0 })} placeholder="0.00" data-testid="form-multa-amb" />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div className="space-y-1">
                <Label className="text-xs">Divisas ($)</Label>
                <div className="h-8 flex items-center justify-end px-3 bg-slate-50 border border-slate-200 rounded-md text-sm font-medium text-slate-700" data-testid="form-divisas-usd-amb">
                  {valorDolar > 0 ? (calcTotal() / valorDolar).toLocaleString("es-VE", { minimumFractionDigits: 2 }) : "0.00"}
                </div>
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Divisas (E)</Label>
                <div className="h-8 flex items-center justify-end px-3 bg-slate-50 border border-slate-200 rounded-md text-sm font-medium text-slate-700" data-testid="form-divisas-eur-amb">
                  {valorEuro > 0 ? (calcTotal() / valorEuro).toLocaleString("es-VE", { minimumFractionDigits: 2 }) : "0.00"}
                </div>
              </div>
              <div className="space-y-1">
                <Label className="text-xs font-bold">Total (Bs.)</Label>
                <div className="h-8 flex items-center justify-end px-3 bg-orange-50 border border-orange-200 rounded-md font-bold text-orange-800 text-sm" data-testid="form-total-amb">
                  {calcTotal().toLocaleString("es-VE", { minimumFractionDigits: 2 })}
                </div>
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => { resetForm(); setDialogOpen(false); }}>Cancelar</Button>
            <Button onClick={() => handleSave({ ...formData, total: calcTotal(), divisas_usd: valorDolar > 0 ? parseFloat((calcTotal() / valorDolar).toFixed(2)) : 0, divisas_eur: valorEuro > 0 ? parseFloat((calcTotal() / valorEuro).toFixed(2)) : 0, con_tasas_meses: conTasasMeses })} className="bg-orange-600 hover:bg-orange-700" data-testid="btn-guardar-calculo-amb">
              {editingItem ? "Actualizar" : "Guardar"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Delete Confirmation */}
      <Dialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle>Confirmar Eliminacion</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">Esta seguro de eliminar este calculo?</p>
          <DialogFooter>
            <Button variant="outline" onClick={() => setDeleteDialogOpen(false)}>Cancelar</Button>
            <Button variant="destructive" onClick={confirmDelete} data-testid="btn-confirm-delete-calculo-amb">Eliminar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <DialogoFechaCaja
        open={fechaCajaDialogOpen}
        onOpenChange={setFechaCajaDialogOpen}
        fechaCalculo={calculoParaEnviar?.fecha}
        onConfirm={() => {
          setFechaCajaDialogOpen(false);
          handleEnviarACaja(calculoParaEnviar, true);
          setCalculoParaEnviar(null);
        }}
        onCancel={() => {
          setFechaCajaDialogOpen(false);
          setCalculoParaEnviar(null);
        }}
      />
    </div>
  );
};

export default CalculoAmbulantes;
